import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { changeReportAdminZones, getListReportsZones } from '../../../../admin/actions/reportActions';
import AdminReportsRoomView from '../../../../containers/ChatRooms/Room/Admin/Room/AdminReportsRoom';

const AdminReportsRoom = ({ match }) => {
    const dispatch = useDispatch()
    const {isLoadingListReports,listOfReports} = useSelector(state=>state.postAdmin)
    useEffect(() => {
        dispatch(getListReportsZones({
            communityID: match.params.idRoom,
            reportedType: "chatconnection"
        }))

        return () => {

        };
    }, [match.params.idRoom]);
    const changeReportAdmin = (values) =>{
        dispatch(changeReportAdminZones(values))
    }
    return (
        <AdminReportsRoomView isLoadingListReports={isLoadingListReports} changeReportAdmin={changeReportAdmin} reports={listOfReports} />
    )
};

export default AdminReportsRoom;
